import {
  IReferral,
  IReferralInteraction,
  ReferralCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  AtLeast,
  CollectionReference,
  Firestore,
  IReffable,
  WithRef,
  multiUndeleted,
  subCollection,
} from '@principle-theorem/shared';
import { Observable } from 'rxjs';

export class ReferralInteraction {
  static init(
    overrides: AtLeast<IReferralInteraction, 'type' | 'content' | 'actor'>
  ): IReferralInteraction {
    return {
      deleted: false,
      ...overrides,
    };
  }

  static col(
    referral: IReffable<IReferral>
  ): CollectionReference<IReferralInteraction> {
    return subCollection<IReferralInteraction>(
      referral.ref,
      ReferralCollection.Interactions
    );
  }

  static all$(
    referral: IReffable<IReferral>
  ): Observable<WithRef<IReferralInteraction>[]> {
    return Firestore.query$(ReferralInteraction.col(referral)).pipe(multiUndeleted());
  }
}
